import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'projects/store/src/environments/environment';
import { CountryCode } from 'projects/store/src/app/enums';
import { PhoneAppState, PhoneAppStatusService } from 'projects/store/src/app/services/api/v1/phone-app-status.service';

@Component({
  selector: 'app-sales-phone-trustonic-prepaid-platform',
  templateUrl: './sales-phone-trustonic-prepaid-platform.component.html'
})
export class SalesPhoneTrustonicPrepaidPlatformComponent implements OnInit, OnDestroy {
  @Input() requestId!: string;
  @Input() otp?: string | null;
  @Input() contractNumber?: string | null;
  @Input() personNumber?: string | null;
  @Input() trustonicAppUrl?: string;
  @Output() nextStep = new EventEmitter<void>();

  appState: PhoneAppState = PhoneAppState.Waiting;
  visibleModal = false;

  private subscription?: Subscription;

  readonly isMexico = environment.global.country.code === CountryCode.MX;

  constructor(private status: PhoneAppStatusService) {}

  ngOnInit(): void {
    this.subscription = this.status.state$.subscribe(state => {
      const wasWaiting = this.appState === PhoneAppState.Waiting;
      this.appState = state;
      if (state === PhoneAppState.Ready && wasWaiting) {
        this.visibleModal = true;
      }
    });
    this.status.start(this.requestId);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.status.stop();
  }

  onContinue(): void {
    this.nextStep.emit();
  }

  get title(): string {
    return this.appState === PhoneAppState.Ready ? 'Registro finalizado' : 'Registro en progreso';
  }

  get subTitle(): string {
    if (this.isMexico) {
      return 'Para continuar, necesitamos que abras la app de Krediya que ha sido instalada, para que puedas reportar tus pagos.';
    }
    return this.appState === PhoneAppState.Ready
      ? 'Hemos recibido confirmación del registro. Presiona "Continuar" para avanzar'
      : 'Para finalizar el registro en KRDYA, por favor ten a mano la cédula o teléfono del crédito y validar el OTP de firma';
  }

  get description(): string {
    return this.appState === PhoneAppState.Waiting ? 'Una vez abierta, te pedirá el siguiente dato:' : '';
  }
}
